import { createBrowserRouter, createRoutesFromElements, Navigate, Route, RouterProvider } from "react-router";
import AuthLayout from "@/auth/Auth.layout";
import { AuthenticationGuard } from "@/auth/Auth.guard";
import WorkspaceAuthGuardWrapper from "./workspace/Workspace.router";
import AppRootLayout from "@/presentation/ui/layouts/app/AppRoot.layout";
import LoadingSpinner from "@/presentation/ui/components/common/LoadingSpinner";
import NotFound from "@/presentation/pages/NotFound";
import AuthError from "@/presentation/pages/auth/Error.page";
import ShareLinkLayout from "@/presentation/pages/share/ShareLinkLayout";
import ShareLinkPage from "@/presentation/pages/share/ShareLinkPage";
import { Sentry } from "@/infrastructure/services/logger";

const HomePage = () => {
  return <Navigate to="/workspace" />;
};

const CallbackPage = () => {
  return <LoadingSpinner />;
};

const SentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV7(
  createBrowserRouter,
)

const router = SentryCreateBrowserRouter(
  createRoutesFromElements(
    <Route element={<AppRootLayout />}>
      <Route path="share" element={<ShareLinkLayout />}>
        <Route path=":resourceSlug/:token" element={<ShareLinkPage />} />
      </Route>
      <Route path="/" element={<AuthLayout />}>
        <Route index element={<AuthenticationGuard component={HomePage} />} />
        <Route path="workspace/*" element={<AuthenticationGuard component={WorkspaceAuthGuardWrapper} />} />
        <Route path="auth">
          <Route path="callback" element={<CallbackPage />} />
          <Route path="error" element={<AuthError />} />
        </Route>
      </Route>
      <Route path="*" element={<NotFound />} />
    </Route>
  )
);

export default function AppRoutes() {
  return <RouterProvider router={router} />;
}
